export default __webpack_public_path__ + "static/media/anusha_profile.111098b5.jpg";